module.exports = __webpack_public_path__ + "img/trade1.4114e03f.jpg";